import { useEffect, useState } from 'react';
import { Space, Text } from '@mantine/core';
import FileUpload from '../../../Organismns/FileUpload';
import PanePaper from '../../../Molecules/PanePaper';
import { RoutingS } from '../../../Service/RoutingS';
import ProfileFilesTable from './ProfileFilesTable';

const PromoMaterial = () => {
  const [lastUpdate, setLastUpdate] = useState(new Date().getMilliseconds());

  useEffect(() => {
    RoutingS.changeTitle('Dateien');
  }, []);

  function reloadData() {
    setLastUpdate(new Date().getMilliseconds());
  }

  return (
    <PanePaper title="Dateien" tooltip="help.settings.files.pane" sx={{ maxWidth: 800 }}>
      <Text mt="xl" weight="bolder" size="md">
        Profil-Daten:
      </Text>
      <FileUpload kind="stuff" reloadCallback={reloadData} />
      <Space h="xl" />
      <ProfileFilesTable lastUpdate={lastUpdate} />
    </PanePaper>
  );
};

export default PromoMaterial;
